// 简体 → 繁体（zh-TW 界面显示数据里的简体文字：城市名、类别、后端提示等）。对照表由 scripts/gen-zh-tw.js 生成，
// 与后端 utils/hant-map.json、移动端同名文件内容相同。逐字取默认写法，一简对多繁的字先看左邻、再看右邻搭配，最后换常用词（登錄 → 登入等）。
// 只用于显示，提交给后端的值（城市名等）仍是简体原文。
import MAP from './hant-map.json';

export function toHant(s) {
  if (!s || typeof s !== 'string') return s;
  let out = '';
  for (let i = 0; i < s.length; i++) {
    const ch = s[i];
    out += MAP.l[s[i - 1] + ch] || MAP.r[ch + s[i + 1]] || MAP.c[ch] || ch;
  }
  return MAP.v.reduce((acc, [from, to]) => acc.split(from).join(to), out);
}

// 后端响应里给人看的提示文字（error / message / details[].msg / blockers）转繁体；数据字段不动
export function hantMessages(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return data;
  const out = { ...data };
  if (typeof out.error === 'string') out.error = toHant(out.error);
  if (typeof out.message === 'string') out.message = toHant(out.message);
  if (Array.isArray(out.details)) out.details = out.details.map((d) => (d && typeof d.msg === 'string' ? { ...d, msg: toHant(d.msg) } : d));
  if (Array.isArray(out.blockers)) out.blockers = out.blockers.map(toHant);
  return out;
}

// 中文原文的显示名：繁体界面转繁体，简体原样（其他语言由调用方自己处理）
export const zhLabel = (s, lang) => (lang === 'zh-TW' ? toHant(s) : s);
